import React from 'react';
export default class RouteBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="wt-events-page"><div role="alert"><h1>This page could not load</h1><p>Your connection may have changed. Reload to try again.</p><button type="button" onClick={() => window.location.reload()}>Reload page</button><a href="/">Whoppatix home</a></div></main>;
  }
}
